function isError(value) {
    return value instanceof Error;
}

export { isError };
